<template>
  <div class="total_main">
    <div class="total_main_total">
      <div v-for="item in totalOptions" :key="item.name">
        <div>
          <img :src="item.icon" alt="" />
          <div>
            <span> {{ item.value }}{{ item.unit }} </span>
            <span>{{ item.name }}</span>
          </div>
        </div>
        <div>
          <div v-for="ite in schoolType" :key="ite.name">
            <span>{{ ite.name }}：</span>
            <span>{{ item[ite.key] }}{{ item.unit }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="total_main_buildcapital">
      <boxStyle title="项目建设情况">
        <template #title_right>
          <a-select default-value="all" style="width: 120px; margin-left: auto" @change="handleChange"
            :dropdownClassName="'customClass'">
            <a-select-option value="all">整体情况</a-select-option>
            <!--<a-select-option value="lucy">Lucy</a-select-option>
            <a-select-option value="disabled">Disabled</a-select-option>
            <a-select-option value="Yiminghe">yiminghe</a-select-option>-->
          </a-select>
        </template>
        <div class="total_main_buildcapital_content">
          <div class="flex:1" ref="buildLeft">2</div>
          <div class="flex:1" ref="buildRight">3</div>
        </div>
      </boxStyle>
      <!-- title="项目资金" -->
      <boxStyle title="微课思政元素">
        <template #title_right>
          <!-- <div class="total_maney">
            <div v-for="item in totalMoneyOptions" :key="item.title">
              <span>{{ item.title }}：</span>
              <span>{{ item.value }}{{ item.unit }}</span>
            </div>
          </div> -->
        </template>
        <div class="total_main_buildcapital_content" style="flex: 1; width: 100%; height: 100%; min-height: 350px"
          ref="wordCharts"></div>
      </boxStyle>
    </div>
    <div class="total_main_center">
      <boxStyle style="flex: 0.3" title="思政工作室中高职成果统计">
        <template #title_right>
          <a-select default-value="all" style="width: 120px; margin-left: auto" @change="handleChange"
            :dropdownClassName="'customClass'">
            <a-select-option value="all">全部</a-select-option>
            <!--<a-select-option value="lucy">Lucy</a-select-option>
            <a-select-option value="disabled">Disabled</a-select-option>
            <a-select-option value="Yiminghe">yiminghe</a-select-option>-->
          </a-select>
        </template>
        <div class="total_main_buildcapital_content" style="flex: 1; width: 100%; height: 100%; min-height: 350px"
          ref="achievements" id="achievements"></div>
      </boxStyle>
      <boxStyle style="flex: 0.3" title="思政实践基地">
        <table class="tables">
          <thead>
            <tr>
              <th>基地名称</th>
              <th>基地地址</th>
              <th>建设时间</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="i in 7" :key="i">
              <td>***</td>
              <td>***</td>
              <td v-if="i == '1'">2021</td>
              <td v-if="i == '2'">2022</td>
              <td v-if="i == '3'"> 2023</td>
              <td v-if="i == '4'"> 2016</td>
              <td v-if="i == '5' || i == '7'"> 2015</td>
              <td v-if="i == '6'"> 2001</td>
            </tr>
          </tbody>
        </table>
      </boxStyle>
      <!-- title="资金预警" -->
      <boxStyle style="flex: 0.4" title="成果统计">
        <table class="tables">
          <thead>
            <tr>
              <!-- <th style="width: 20%">名称</th>
              <th style="width: 20%">学校名称</th>
              <th style="width: 10%">类型</th>
              <th style="width: 10%">总金额</th>
              <th style="width: 10%">剩余金额</th> -->
              <th style="width: 40%">学校名称</th>
              <th style="width: 30%">思政工作室成果数量</th>
              <th style="width: 30%">特色文化育人品牌成果数量</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <!-- <td style="width: 20%">传承中国铁路精神培养时代铁路工匠</td>
              <td style="width: 20%">太原铁路机械学校</td>
              <td style="width: 10%">特色文化育人品牌</td>
              <td style="width: 10%">23万元</td>
              <td style="width: 10%">6万元</td> -->
              <td style="width: 40%">太原铁路机械学校</td>
              <td style="width: 30%">23</td>
              <td style="width: 30%">6</td>
            </tr>
            <tr>
              <!-- <td style="width: 20%">岗课赛证四化技能成就人生</td>
              <td style="width: 20%">太原铁路机械学校</td>
              <td style="width: 10%">特色文化育人品牌</td>
              <td style="width: 10%">18万元</td>
              <td style="width: 10%">2万元</td> -->
               <td style="width: 40%">太原铁路机械学校</td>
              <td style="width: 30%">18</td>
              <td style="width: 30%">2</td>
            </tr>
            <tr>
              <!-- <td style="width: 20%">“启智润心“思政教育工作室</td>
              <td style="width: 20%">山西省贸易学校</td>
              <td style="width: 10%">思政工作室</td>
              <td style="width: 10%">25万元</td>
              <td style="width: 10%">2万元</td> -->
               <td style="width: 40%">山西省贸易学校</td>
              <td style="width: 30%">25</td>
              <td style="width: 30%">2</td>
            </tr>
            <tr>
              <!-- <td style="width: 20%">“德沁法润”思政教育工作室</td>
              <td style="width: 20%">山西省司法学校</td>
              <td style="width: 10%">思政工作室</td>
              <td style="width: 10%">17万元</td>
              <td style="width: 10%">2万元</td> -->
                <td style="width: 40%">山西省司法学校</td>
              <td style="width: 30%">17</td>
              <td style="width: 30%">2</td>
            </tr>
            <tr>
              <!-- <td style="width: 20%">精卫思政教育工作室</td>
              <td style="width: 20%">太原市卫生学校</td>
              <td style="width: 10%">思政工作室</td>
              <td style="width: 10%">13万元</td>
              <td style="width: 10%">2万元</td> -->
                  <td style="width: 40%">太原市卫生学校</td>
              <td style="width: 30%">13</td>
              <td style="width: 30%">2</td>
            </tr>
          </tbody>
        </table>
      </boxStyle>
    </div>
    <div class="total_main_bottom">
      <boxStyle style="flex: 0.3" title="品牌文化">
        <template #title_right>
          <a-radio-group style="margin-left: auto" default-value="a" button-style="solid">
            <a-radio-button value="a"> 文化 </a-radio-button>
            <a-radio-button value="d"> 精神 </a-radio-button>
          </a-radio-group>
        </template>
        <div class="total_main_buildcapital_content" style="
            flex: 1;
            width: 100%;
            height: 100%;
            min-height: 350px;
            transform: translate3d(0, 0, 0);
          " ref="brandTag"></div>
      </boxStyle>
      <boxStyle style="flex: 0.3" title="品牌内涵">
        <div class="total_main_buildcapital_content" style="flex: 1; width: 100%; height: 100%; min-height: 350px"
          ref="wordChart"></div>
      </boxStyle>

      <boxStyle style="flex: 0.4" title="学校项目">
        <table class="tables">
          <thead>
            <tr>
              <th style="width: 35%">学校名称</th>
              <!-- <th style="width: 10%">资金总额</th> -->
              <th style="width: 17%">思政工作室数量</th>
              <th style="width: 25%">特色文化育人品牌数量</th>
              <th style="width: 15%">思政微课数量</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="width: 35%;cursor:pointer;" v-if="$route.query.name != '临汾市'"
                @click="gopath({ realname: '太原城市职业技术学院' })">太原城市职业技术学院</td>
              <td style="width: 35%;cursor:pointer;" v-else @click="gopath({ realname: '山西省曲沃县中等职业技术学校' })">
                山西省曲沃县中等职业技术学校
              </td>
              <!-- <td style="width: 10%">226</td> -->
              <td style="width: 17%">1</td>
              <td style="width: 25%">4</td>
              <td style="width: 15%">54</td>
            </tr>
            <tr>
              <td style="width: 35%;cursor:pointer;" @click="gopath({ realname: '太原旅游职业学院' })">太原旅游职业学院</td>
              <!-- <td style="width: 10%">235</td> -->
              <td style="width: 17%">1</td>
              <td style="width: 25%">11</td>
              <td style="width: 15%">77</td>
            </tr>
            <tr>
              <td style="width: 35%;cursor:pointer;" @click="gopath({ realname: '太原市财贸学校' })">太原市财贸学校</td>
              <!-- <td style="width: 10%">240</td> -->
              <td style="width: 17%">1</td>
              <td style="width: 25%">22</td>
              <td style="width: 15%">65</td>
            </tr>
            <tr>
              <td style="width: 35%;cursor:pointer;" @click="gopath({ realname: '太原市财政金融学校' })">太原市财政金融学校</td>
              <!-- <td style="width: 10%">216</td> -->
              <td style="width: 17%">1</td>
              <td style="width: 25%">1</td>
              <td style="width: 15%">95</td>
            </tr>
            <tr>
              <td style="width: 35%;cursor:pointer;" @click="gopath({ realname: '太原市交通学校' })">太原市交通学校</td>
              <!-- <td style="width: 10%">233</td> -->
              <td style="width: 17%">0</td>
              <td style="width: 25%">3</td>
              <td style="width: 15%">70</td>
            </tr>
            <tr>
              <td style="width: 35%;cursor:pointer;" @click="gopath({ realname: '太原生态工程学校' })">太原生态工程学校</td>
              <!-- <td style="width: 10%">241</td> -->
              <td style="width: 17%">0</td>
              <td style="width: 25%">3</td>
              <td style="width: 15%">43</td>
            </tr>
            <tr>
              <td style="width: 35%;cursor:pointer;" @click="gopath({ realname: '太原市第七职业中学' })">太原市第七职业中学</td>
              <!-- <td style="width: 10%">247</td> -->
              <td style="width: 10%">0</td>
              <td style="width: 10%">1</td>
              <td style="width: 15%">10</td>
            </tr>
          </tbody>
        </table>
      </boxStyle>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import Highcharts from "highcharts";

import boxStyle from "@/components/bigData/boxStyle.vue";
import 'echarts-wordcloud';
export default {
  components: { boxStyle },
  data: () => {
    return {
      totalOptions: [
        {
          icon: require("@/assets/images/bigData/total_school.png"),
          name: "全市学校",
          value: "64",
          unit: "所",
          zy: "0",
          gz: "25",
          zz: "35",
          jg: "4",
        },
        // {
        //   icon: require("@/assets/images/bigData/total_money.png"),
        //   name: "预算资金",
        //   value: "xxx",
        //   unit: "万元",
        //   zy: "xxx",
        //   gz: "xxx",
        //   zz: "xxx",
        //   jg: "xxx",
        // },
        {
          icon: require("@/assets/images/bigData/total_home.png"),
          name: "思政工作室",
          value: "34",
          unit: "个",
          zy: "0",
          gz: "29",
          zz: "5",
          jg: "0",
        },
        {
          icon: require("@/assets/images/bigData/total_pinpai.png"),
          name: "特色文化育人品牌",
          value: "321",
          unit: "个",
          zy: "0",
          gz: "217",
          zz: "102",
          jg: "8",
        },
        {
          icon: require("@/assets/images/bigData/total_book.png"),
          name: "思政微课",
          value: "2260",
          unit: "个",
          zy: "0",
          gz: "1385",
          zz: "809",
          jg: "66",
        },
      ],
      schoolType: [
        {
          name: "职业本科",
          key: "zy",
        },
        {
          name: "高职院校",
          key: "gz",
        },
        {
          name: "中职院校",
          key: "zz",
        },
        {
          name: "技工院校",
          key: "jg",
        },
      ],
      totalMoneyOptions: [
        { title: "预算金额", value: "****", unit: "万元" },
        { title: "实际资金使用", value: "****", unit: "万元" },
      ],
    };
  },
  mounted() {
    this.buildLeft();
    this.buildRight();
    // this.totalManey();
    this.achievementsAct();
    // this.星星星();
    this.brandTagAct();
    this.getWordChart();
    this.getWordCharts();
  },
  methods: {
     getWordCharts() {
      const chart = echarts.init(this.$refs.wordCharts);
      chart.setOption({
        series: [{
          type: 'wordCloud',
          data: [
            { 'name': '胸怀理想', 'value': 13 },
            { 'name': '建功立业', 'value': 14 },
            { 'name': '民族自信', 'value': 16 },
            { 'name': '顽强拼搏', 'value': 15},
            { 'name': '文化自信', 'value': 12 },
            { 'name': '奋发图强', 'value': 13},
            { 'name': '刚健有为', 'value': 14 },
            // { 'name': 'Vue', 'value': 100 }
            // { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            //  { 'name': 'Vue', 'value': 100 },
            ],
          sizeRange: [16, 30],
          textStyle: { color: () => this.randomColor(),fontSize: '18-50' }
        }]
      });
    },
    gopath(item) {
      this.$router.push({
        path: '/home/schoolAnalyse',
        query: {
          name: item.realname,
          // schoolid:item.id,
        }
      });
    },
    buildLeft() {
      var myChart = echarts.init(this.$refs.buildLeft);
      let option = {
        title: {
          text: "",
        },
        legend: {
          data: ["思政工作室", "特色文化育人品牌", "思政微课"],
          left: "center",
          textStyle: {
            color: "#E9EAEF", // 设置图例文本颜色
          },
          itemWidth: 12, // 设置图例标记的宽度
          itemHeight: 8,
        },
        radar: {
          // shape: 'circle',
          indicator: [
            { name: "职业本科", max: 8000 },
            { name: "技工院校", max: 8000 },
            { name: "中职院校", max: 8000 },
            { name: "高职院校", max: 8000 },
          ],
          shape: "polygon",
          radius: "60%",
          splitNumber: 5,
          name: {
            textStyle: {
              color: "#fff", // 指示器名称的文字颜色
            },
          },
          axisLine: {
            lineStyle: {
              color: "#004779", // 中间x轴和y轴的颜色
            },
          },
          splitLine: {
            lineStyle: {
              color: ["#004779", "#004779", "#004779"], // 分隔线颜色
            },
          },
          splitArea: {
            // 区域填充样式
            show: true, // 显示分隔区域
            areaStyle: {
              color: ["rgba(0,0,0,0)", "RGBA(0, 46, 113,0.5)"], // 分割区域的颜色数组
            },
          },
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            name: "Budget vs spending",
            type: "radar",
            data: [
              {
                value: [0, 0, 5, 29],
                name: "思政工作室",
                itemStyle: {
                  color: "#5470C6",
                },
              },
              {
                value: [0, 8, 102, 217],
                name: "特色文化育人品牌",
                itemStyle: {
                  color: "#91CC75",
                },
              },
              {
                value: [0, 66, 809, 1385],
                name: "思政微课",
                itemStyle: {
                  color: "#FAC858",
                },
              },
            ],
          },
        ],
      };
      myChart.clear();
      myChart.setOption(option);
    },
    buildRight() {
      let value = ["2021", "2022", "2023"];
      let value1 = [15, 127, 553];
      let value2 = [9, 100, 833];
      let value3 = [10, 94, 874];
      let VALUE5 = ["思政工作室", "特色文化育人品牌", "思政微课"];
      var myChart = echarts.init(this.$refs.buildRight);
      let option = {
        grid: {
          containLabel: true,
          left: 5,
          right: 15,
          bottom: 15,
          top: 48,
        },
        legend: {
          data: VALUE5,
          textStyle: {
            color: "#ffffff", //字体颜色
          },
          origent: "right",
          top: 0,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: value,
          axisLabel: {
            textStyle: {
              color: "#68A8CC",
            },
            formatter: function (value) {
              let rowMAx = 4;
              let overValue = "";
              for (let i = 0; i < value.length; i++) {
                if (i % rowMAx == 0 && i != 0) {
                  overValue += "\n";
                  overValue += value[i];
                } else {
                  overValue += value[i];
                }
              }
              return overValue;
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#3c71c1",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "(个)",
          nameTextStyle: {
            color: "#68A8CC",
          },
          axisLabel: {
            textStyle: {
              color: "#68A8CC",
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#68A8CC",
            },
          },
          splitLine: {
            // y 轴分隔线配置
            show: true, // 是否显示分隔线
            lineStyle: {
              color: "#68A8CC", // 分隔线颜色
            },
          },
        },
        series: [
          {
            name: VALUE5[0],
            data: value1,
            type: "bar",
            barWidth: "15",
            barGap: "40%",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0.3,
                      color: "#56feff", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#0118ab", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
            showBackground: false,
            backgroundStyle: {
              color: "#04195e",
            },
            label: {
              show: true,
              position: "top",
              color: "#fff",
            },
          },
          {
            name: VALUE5[1],
            data: value2,
            type: "bar",
            barWidth: "15",
            barGap: "40%",
            showBackground: false,
            backgroundStyle: {
              color: "#04195e",
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0.4,
                      color: "#9ff077", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#0a781b", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
            label: {
              show: true,
              position: "top",
              color: "#fff",
            },
          },
          {
            name: VALUE5[2],
            data: value3,
            type: "bar",
            barGap: "40%",
            barWidth: "15",
            showBackground: false,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0.4,
                      color: "#ffff78", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#d94a1a", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
            label: {
              show: true,
              position: "top",
              color: "#fff",
            },
            legend: {
              color: "#011b60",
            },
          },
        ],
      };
      myChart.clear();
      myChart.setOption(option);
    },
    totalManey() {
      var myChart = echarts.init(this.$refs.totalManey);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        toolbox: {
          show: false,
        },
        legend: {
          data: ["总金额", "总支出", "资金使用率"],
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          containLabel: true,
          left: 5,
          right: 15,
          bottom: 15,
          top: 30,
        },
        xAxis: [
          {
            type: "category",
            data: ["省资金", "地市资金", "学校自筹", "其他资金"],
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              textStyle: {
                color: "#AADDFF",
              },
              formatter: function (value) {
                let rowMAx = 4;
                let overValue = "";
                for (let i = 0; i < value.length; i++) {
                  if (i % rowMAx == 0 && i != 0) {
                    overValue += "\n";
                    overValue += value[i];
                  } else {
                    overValue += value[i];
                  }
                }
                return overValue;
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#0F2C70",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "(万元)",
            min: 0,
            max: 250,
            interval: 50,
            axisLabel: {
              formatter: "{value}",
            },
            nameTextStyle: {
              color: "#63A1C6",
            },
            axisLabel: {
              textStyle: {
                color: "#63A1C6",
              },
            },
          },
          {
            type: "value",
            name: "(%)",
            min: 0,

            max: 100,
            interval: 20,
            axisLabel: {
              formatter: "{value}%",
            },
            nameTextStyle: {
              color: "#63A1C6",
            },
            axisLabel: {
              textStyle: {
                color: "#63A1C6",
              },
            },
          },
        ],
        series: [
          {
            name: "总金额",
            type: "bar",
            barWidth: "20",
            tooltip: {
              valueFormatter: function (value) {
                return value + "";
              },
            },
            itemStyle: {
              normal: {
                borderColor: "#0095fe", // 描边颜色
                borderWidth: 2, // 描边宽度
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0.3,
                      color: "#0096FFee", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#000000bb", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
            data: [162.2, 32.6, 200, 20],
          },
          {
            barWidth: "20",
            name: "总支出",
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value + "";
              },
            },
            itemStyle: {
              normal: {
                borderColor: "#d78404", // 描边颜色
                borderWidth: 2, // 描边宽度
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0.3,
                      color: "#ff9f0dee", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#000000bb", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
            data: [48.7, 18.8, 15, 10],
          },
          {
            name: "资金使用率",
            type: "line",
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + "%";
              },
            },
            lineStyle: {
              color: "#38CEC1", // 修改折线颜色
            },
            itemStyle: {
              color: "#fff", // 点的填充颜色
              borderColor: "#38CEC1", // 点的描边颜色
              borderWidth: 2, // 描边宽度
            },
            data: [60, 75, 80, 40],
          },
        ],
      };
      myChart.clear();
      myChart.setOption(option);
    },
    achievementsAct() {
      var myChart = echarts.init(this.$refs.achievements);
      let color = ["#FFD900", "#517FD9", "#FF7E00", "#00A1E4"];
      let data1 = [
        {
          value: 120,
          name: "职业本科",
          value1: "95",
          label: {
            textStyle: {
              color: "#FFD900",
              fontSize: 18,
              fontWeight: 600,
              borderColor: "#FFD900",
            },
          },
        },
        {
          value: 20,
          name: "高职院校",
          value1: "90",
          label: {
            textStyle: {
              color: "#517FD9",
              fontSize: 18,
              fontWeight: 600,
              borderColor: "#517FD9",
            },
          },
        },
        {
          value: 156,
          name: "中职院校",
          value1: "80",
          label: {
            textStyle: {
              color: "#FF7E00",
              fontSize: 18,
              fontWeight: 600,
              borderColor: "#FF7E00",
            },
          },
        },
        {
          value: 33,
          name: "技工院校",
          value1: "70",
          label: {
            textStyle: {
              color: "#00A1E4",
              fontSize: 18,
              fontWeight: 600,
              borderColor: "#00A1E4",
            },
          },
        },
      ];
      data1.sort(function (a, b) {
        return a.value - b.value;
      });
      color.splice(data1.length, data1.length - 1);
      data1.map((item, index) => {
        data1.push({ value: 0, name: "" });
        color.push("transparent");
      });
      let option = {
        backgroundColor: "",
        title: {
          text: "",
        },
        tooltip: {
          show: false,
        },
        legend: {
          icon: "circle",
          top: "1%",
          textStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            name: "玫瑰图",
            type: "pie",
            startAngle: 180,
            radius: [50, 100],
            center: ["50%", "90%"],
            roseType: "area",
            avoidLabelOverlap: false,
            itemStyle: {
              normal: {
                color: function (params) {
                  return color[params.dataIndex];
                },
              },
            },
            label: {
              show: true,
              fontSize: 14,
              formatter: function (params) {
                //				                	  console.log(params);
                return params.value
                  ? "{a|" +
                  params.value +
                  "}%\n " +
                  "{hr|}\n" + // 插入水平线
                  "{b|" +
                  params.name +
                  "}" // 这里可以添加更多的文本或变量
                  : "";
              },
              textStyle: {
                color: "#ftt",
              },
              rich: {
                hr: {
                  width: "100%",
                  borderWidth: 0.5,
                  borderColor: "#fff",
                  height: 0,
                },
                b: {
                  color: "#fff",
                },
                // 可以添加更多的样式定义
              },
            },
            labelLine: {
              normal: {
                length: 10,
                length2: 10,
                show: true,
                lineStyle: {
                  width: 1,
                },
              },
            },
            data: data1,
          },
        ],
      };
      myChart.clear();
      myChart.setOption(option);
    },
    星星星() {
      Highcharts.chart(this.$refs["****"], {
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 50,
            beta: 0,
          },
          backgroundColor: null,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: null,
        },
        legend: {
          enabled: true,
          itemStyle: {
            color: "#fff",
            fontSize: "10",
          },
          //   width: 100, // 设置图例宽度
          symbolHeight: 10, // 调整图例符号高度
          symbolWidth: 10, // 调整图例符号宽度
          symbolRadius: 0, // 调整图例符号圆角
          //        itemMarginTop: 10,
          align: "center", // 图例水平对齐方式（可选值：'left', 'center', 'right'）
          verticalAlign: "bottom", // 图例垂直对齐方式（可选值：'top', 'middle', 'bottom'）
          labelFormatter: function () {
            return this.name;
          },
        },
        plotOptions: {
          pie: {
            size: 250,
            showInLegend: true,
            allowPointSelect: true, //每个扇块能否选中
            depth: 30, //饼图的厚度
            borderWidth: 2,
            borderColor: "#FFFFFF", // 设置边框颜色为白色
            dataLabels: {
              distance: 20, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
              enabled: false, //是否显示饼图的线形tip
            },
          },
        },
        series: [
          {
            // size: 150,
            name: "品牌归属",
            data: [
              ["农林牧渔大类", 11],
              ["资源环境与安全大类", 6],
              ["能源动力与材料大类", 2],
              ["土木建筑大类", 7],
              ["水利大类", 4],
              ["装备制造大类", 11],
              ["生物与化工大类", 6],
              ["轻工纺织大类", 2],
              ["食品药品与粮食大类", 7],
              ["交通运输大类", 4],
              ["电子与信息大类", 11],
              ["医药卫生大类", 6],
              ["财经商贸大类", 2],
              ["旅游大类", 7],
              ["文化与艺术大类", 4],
            ],
            colors: ["#80CB4B", "#FFC808", "#FE8D37", "#517FD9", "#38CEC1"],
          },
        ],
      });
    },
    brandTagAct() {
      var myChart = echarts.init(this.$refs.brandTag);
      let list = [
        {
          name: "非遗文化",
          value: 8,
          label: {
            textStyle: {
              color: "#106bff",
              fontSize: 18,
              fontWeight: 600,
              borderColor: "#517FD9",
            },
          },
        },
        {
          name: "革命文化",
          value: 4,
          label: {
            textStyle: {
              color: "#00b8ff",
              fontSize: 18,
              fontWeight: 600,
              borderColor: "#517FD9",
            },
          },
        },
        {
          name: "红色文化",
          value: 33,
          label: {
            textStyle: {
              color: "#ff6262",
              fontSize: 18,
              fontWeight: 600,
              borderColor: "#517FD9",
            },
          },
        },
        {
          name: "传统文化",
          value: 48,
          label: {
            textStyle: {
              color: "#ffb81a",
              fontSize: 18,
              fontWeight: 600,
              borderColor: "#517FD9",
            },
          },
        },
        {
          name: "其他",
          value: 7,
          label: {
            textStyle: {
              color: "#6fef33",
              fontSize: 18,
              fontWeight: 600,
              borderColor: "#517FD9",
            },
          },
        },
      ];
      let list1 = [
        {
          name: "非遗文化",
          value: 8,
          itemStyle: { color: 'rgba(16,108,255,0.3)' }
        },
        {
          name: "革命文化",
          value: 4,
          itemStyle: { color: 'rgba(0,184,255,0.3)' }
        },
        {
          name: "红色文化",
          value: 33,
          itemStyle: { color: 'rgba(255,98,98,0.3)' }
        },
        {
          name: "传统文化",
          value: 48,
          itemStyle: { color: 'rgba(255,184,26,0.3)' }
        },
        {
          name: "其他",
          value: 7,
          itemStyle: { color: 'rgba(111,239,51,0.3)' }
        },
      ];
      let angle = 0;
      let option = {
        color: [
          "#106bff",
          "#00b8ff",
          "#ff6262",
          "#ffb81a",
          "#6fef33",
          "#106bff",
          "#8d4bbb",
          "#6635EF",
          "#FFAFDA",
        ],
        tooltip: {
          show: false,
        },
        legend: {
          show: false,
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            selectedMode: "single",
            radius: ["37%", "48%"],

            label: {
              normal: {
                show: false,
                position: "inner",
                formatter: "{d}%",
                textStyle: {
                  color: "#fff",
                  fontWeight: "normal",
                  fontSize: 20,
                },
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                borderColor: "#001553",
                borderWidth: 4,
              },
            },
            data: list1,
          },
          {
            itemStyle: {
              normal: {
                borderColor: "#001553",
                borderWidth: 4,
              },
            },
            name: "访问来源",
            type: "pie",
            radius: ["57%", "68%"],
            label: {
              normal: {
                formatter: "{b|{d}%}\n{hr|}\n{d|{b}}",
                rich: {
                  b: {
                    fontSize: 16,
                    align: "left",
                    padding: 4,
                  },
                  hr: {
                    borderColor: "#12EABE",
                    width: "100%",
                    borderWidth: 2,
                    height: 0,
                  },
                  d: {
                    fontSize: 16,
                    color: "#fff",
                    align: "left",
                    padding: 4,
                  },
                  c: {
                    fontSize: 16,
                    color: "#fff",
                    align: "center",
                    padding: 4,
                  },
                },
              },
            },
            labelLine: {
              normal: {
                show: true,
                length: 10,
                length2: 10,
                lineStyle: {
                  type: "dashed",
                  width: 2,
                },
              },
            },
            data: list,
          },
          {
            name: "ring5",
            type: "custom",
            hoverAnimation: false,
            clockwise: true,
            coordinateSystem: "none",
            z: 20, // 设置 markPoint 的 z-index
            zlevel: 2, // 设置 markPoint 的 zlevel
            renderItem: function (params, api) {
              return {
                type: "arc",
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.25,
                  startAngle: ((270 + -angle) * Math.PI) / 180,
                  endAngle: ((40 + -angle) * Math.PI) / 180,
                },
                style: {
                  shadowColor: "#4FADFD",
                  shadowBlur: 10,
                  stroke: "#0CD3DB",
                  fill: "transparent",
                  lineWidth: 1.5,
                },
                silent: true,
              };
            },
            data: [0],
          },
          {
            name: "访问来源",
            type: "pie",
            clockwise: true,
            hoverAnimation: false,
            coordinateSystem: "none",
            radius: ["0%", "20%"],
            data: [100],
            itemStyle: {
              normal: {
                color: "#043173",
              },
            },
            label: {
              show: false,
            },
            labelLine: {
              normal: {
                show: false,
                length: 20,
                length2: 20,
                lineStyle: {
                  type: "dashed",
                  width: 2,
                },
              },
            },
          },
        ],
      };
      function draw() {
        angle = angle + 3;
        myChart.setOption(option, true);
        //window.requestAnimationFrame(draw);
      }

      myChart.on("finished", function () {
        setInterval(function () {
          //用setInterval做动画感觉有问题
          draw();
        }, 100);
        // 在这里执行你想要在渲染完成后执行的代码
      });

      myChart.setOption(option);
    },
    getWordChart() {
      const chart = echarts.init(this.$refs.wordChart);
			chart.setOption({
				series: [{
					type: 'wordCloud',
					data: [
						{ 'name': '爱国主义', 'value': 13 },
						{ 'name': '理想信念', 'value': 14 },
						{ 'name': '责任担当', 'value': 16 },
						{ 'name': '大国工匠', 'value': 15 },
						{ 'name': '劳模精神', 'value': 12 },
						{ 'name': '劳动精神', 'value': 13 },
						{ 'name': '法治规范', 'value': 15 },
						{ 'name': '社会主义核心价值观', 'value': 15 },
						{ 'name': '道德修养', 'value': 17 },],
					sizeRange: [16, 30],
					textStyle: { color: () => this.randomColor(), fontSize: '18-50' }
				}]
			});
    },
    randomColor() {
      const h = Math.floor(Math.random() * 360);
			const s = 80 + Math.floor(Math.random() * 20);
			const l = 60 + Math.floor(Math.random() * 30);

			// HSL转RGB再转HEX
			const a = s * Math.min(l, 100 - l) / 100;
			const f = n => {
				const k = (n + h / 30) % 12;
				const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
				return Math.round(255 * color / 100).toString(16).padStart(2, '0');
			};
			return `#${f(0)}${f(8)}${f(4)}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.total_main {
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex: 1;

  >div {
    >div {
      &:not(:last-child) {
        margin-right: 0.4vw;
      }
    }
  }

  &_total {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    min-height: 120px;
    margin-bottom: 12px;

    >div {
      flex: 1;
      background: url("~@/assets/images/bigData/total_bg.png") no-repeat;
      background-size: 100% 100%;
      padding: 0.9vh 0.22vw;
      display: flex;
      flex-direction: row;

      >div {
        display: flex;
        flex: 1;
        padding: 0px 0.2vw;

        &:first-child {
          display: flex;
          justify-content: center;
          align-items: center;

          >img {
            width: 2.5vw;
            height: 2.5vw;
          }

          >div {
            display: flex;
            flex-direction: column;

            >span {
              text-align: left;
              font-family: MicrosoftYaHei, MicrosoftYaHei;
              font-style: normal;
              text-transform: none;

              &:first-child {
                font-weight: bold;
                font-size: 1vw;
                color: #ffd70e;
              }

              &:last-child {
                font-size: 1vw;
                color: #ffffff;
              }
            }
          }
        }

        &:last-child {
          display: flex;
          align-content: center;
          /*align-items: center;*/
          justify-content: center;
          flex-direction: column;

          >div {
            font-family: MicrosoftYaHei;
            font-size: 0.8vw;
            color: #ffffff;
            text-align: left;
            font-style: normal;
            text-transform: none;

            >span {
              &:last-child {
                color: #66d6dc;
              }
            }
          }
        }
      }

      &:not(:last-child) {
        margin-right: 9px;
      }
    }
  }

  &_buildcapital {
    display: flex;
    flex-direction: row;

    &_content {
      flex: 1;
      width: 100%;
      display: flex;
      min-height: 350px;
      padding: 20px;

      >div {
        flex: 1;

        &:first-child {
          min-width: 350px;
          flex: 0.4;
          border-right: 1px solid #072b72;
        }
      }
    }
  }

  &_center {
    display: flex;
    flex-direction: row;
  }

  &_bottom {
    display: flex;
    flex-direction: row;
  }
}

.total_maney {
  display: flex;
  flex: 1;
  justify-content: flex-end;

  >div {
    &:first-child {
      margin-right: 15px;
    }

    >span {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      font-weight: 400;

      &:first-child {
        color: #ffffff;
      }

      &:last-child {
        color: #efcb1a;
      }
    }
  }
}

.tables {
  width: 100%;

  thead {
    tr {
      background-color: #082569;
      height: 47px;

      th {
        width: 20%;
        height: 30px;
        font-weight: 500;
        line-height: 30px;
        text-align: center;
        font-size: 0.9vw;
        color: #8298fb;
      }
    }
  }

  tbody {
    tr {
      height: 25px;
      border-bottom: 1px solid #213e78;

      td {
        width: 20%;
        height: 25px;
        font-weight: 300;
        line-height: 25px;
        text-align: center;
        font-size: 0.8vw;
      }
    }
  }
}

::-webkit-scrollbar {
  width: 0px;
  /* 滚动条宽度 */
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* 滚动条轨道背景色 */
  border-radius: 10px;
  /* 可选：轨道圆角 */
}

::-webkit-scrollbar-thumb {
  background: #888;
  /* 滚动条颜色 */
  border-radius: 10px;
  /* 可选：滚动条圆角 */
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
  /* 鼠标悬停时滚动条颜色 */
}

* {
  transform: translate3d(0, 0, 0);
}
</style>
